// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3LxQP","actions":"GroupTable_actions__E3l6I","deleteModalFooter":"GroupTable_deleteModalFooter__1gR9F"};